import React from 'react';

import { UpdateViolationDtoFormFieldEnum } from 'lib_api/lib/api/gen';

import { Input } from 'components/WrappedComponents';
import { useApi } from 'hooks/ApiStoreContext';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';
import { CSSUtils } from 'utils/CSSUtils';

import { ModificationUtilisateurFormValues } from '../ModalModification';
import {
  generateUpdateUserRequestDtoFromFormData,
  ModificationUserFieldProps,
  validateUpdateUserRequest,
} from '../utils';

function InputLastName({
  values,
  userId,
}: ModificationUserFieldProps): React.ReactElement {
  const cuController = useApi().ComptesUtilisateursControllerApi;
  const key: keyof ModificationUtilisateurFormValues = 'lastName';

  return (
    <Input
      wrapperProps={{
        values: values,
        fieldKey: key,
        itemProps: {
          label: 'Nom',
          rules: [
            {
              required: true,
              validator: async (
                _rule,
                value: string | undefined,
              ): Promise<void> => {
                const requestObject = generateUpdateUserRequestDtoFromFormData({
                  ...values,
                  lastName: value === '' ? undefined : value,
                });

                return await validateUpdateUserRequest(
                  userId,
                  cuController,
                  requestObject,
                  UpdateViolationDtoFormFieldEnum.LASTNAME,
                );
              },
            },
          ],
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
        },
      }}
      inputProps={{ placeholder: FormPlaceholders.Input }}
    />
  );
}

export default InputLastName;
